import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="site-footer" className={styles.siteFooter}>
      <div id="copyright" className={styles.copyright}>
        <span>
          &copy; {currentYear} <Link to="/" className="evergreen">Linus Marco</Link>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
